import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminPartners_template } from '../../components/templates/recruiting/adminPartners_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
export class admin_partners extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_partners';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Partners');
        this.tpl = new adminPartners_template('adminPartnersTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     * List loads immediately; filter references load in parallel.
     *
     * @return void
     */
    fillPage() {
        this.updateViewModelFromPath();
        this.tpl.setDefaultStatus();
        this.getListData();
        this.getReferences();
    }
    /**
     * Return references used by list filters.
     *
     * @return void
     */
    getReferences() {
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/offer/references', [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for references.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const vm = obj.tpl.getTemplateViewModel();
                const prevStatus = String(vm.status());
                const prevChannel = String(vm.channelId());
                obj.tpl.setReferences(responseParsed);
                obj.tpl.setDefaultStatus();
                const nextStatus = String(vm.status());
                const nextChannel = String(vm.channelId());
                if (nextStatus !== prevStatus || nextChannel !== prevChannel) {
                    obj.getListData();
                }
            });
        };
    }
    /**
     * Return list data.
     *
     * @return void
     */
    getListData() {
        startListLoading(this, this.tpl.builtTemplate);
        this.sendFilterCall('/api/admin/rest/api/lead/offer', this.tpl.getViewModelForRequest(), this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getPartners');
    }
    /**
     * Handle the API response for data request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const rows = (responseParsed.data && responseParsed.data.paginatedData) || responseParsed.data || [];
                const totalCount = Number(responseParsed.totalCount || 0);
                const totalPages = Math.max(1, Number(responseParsed.totalPage || 1));
                const paginationVm = obj.tpl.getPaginationViewModel();
                if (paginationVm && typeof paginationVm.pageNumber === 'function') {
                    paginationVm.pageNumber(Math.max(1, Number(responseParsed.currentPage || paginationVm.pageNumber())));
                }
                obj.validationTemplate.clearMessages();
                obj.tpl.setPartners(rows);
                obj.tpl.updatePagination(totalCount);
                obj.tpl.setResultInfo(totalCount, totalPages, Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                stopListLoading(obj, obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Handle filter on change changes.
     *
     * @return void
     */
    filterOnChange() {
        this.tpl.resetPageNumber();
        this.getListData();
    }
    /**
     * Handle pagination click events.
     *
     * @return void
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Handle list reorder.
     *
     * @return void
     */
    listReorder() {
        this.getListData();
    }
    /**
     * Navigate to create partner.
     *
     * @return void
     */
    createPartner() {
        page('/admin/offerManagement/new');
    }
    /**
     * Navigate to edit partner.
     *
     * @param id number
     * @return void
     */
    editPartner(id) {
        page('/admin/offerManagement/' + id);
    }
}
